'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".FileUpload-module_previews__zAUnj{display:flex;flex-wrap:wrap;gap:24;justify-content:center;width:100%}.FileUpload-module_preview__kDzgL{position:\"relative\"}.FileUpload-module_thumbnail__3PRX1{display:block;width:150}";
var styles = {"previews":"FileUpload-module_previews__zAUnj","preview":"FileUpload-module_preview__kDzgL","thumbnail":"FileUpload-module_thumbnail__3PRX1"};
styleInject["default"](css_248z, '037d7d05-bcd7-4881-b34f-b22ae747cab2');

exports["default"] = styles;
